import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    font-size: 16px;
    line-height: 1.5;
  }

  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  body {
    font-family: 'McKinsey Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  .appContainer {
    background: ${
      /* istanbul ignore next */
      (props) => props.theme.backgroundColor
    };
    background: ${
      /* istanbul ignore next */
      (props) => props.theme.backgroundImageUrl
    };
    background-size: cover;
    min-height: 100%;
    min-width: 100%;
  }

  /** Default input stylings for Mozilla **/
  input::-webkit-input-placeholder {
    color: #b3b3b3;
    font-weight: 400;
    font-size: 14px;
  }
  input:-moz-placeholder {
    color: #b3b3b3;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
  }

  /** Alert styles overwriting **/
  .mds-alert[class$="-Alert"] {
    min-width: 0;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    margin-left: 0;
    margin-right: 0;
    justify-content: center;
  }

  .mds-alert[class$="-Alert"] > div[class$="-Alert"] {
    width: 100%;
    justify-content: center;
  }

  .mds-alert-buttons:empty {
    display: none;
  }

  .mds-alert-content[class$="-Alert"] {
    min-width: 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .mds-alert-content[class$="-Alert"] .mds-alert-icon[class$="-Alert"] {
    flex: 0 0 auto;
  }

  .mds-alert-content[class$="-Alert"] .mds-alert-icon[class$="-Alert"] + div {
    width: auto;
    max-width: 100%;
    flex: 0 1 auto;
    text-align: center;
  }

  @media screen and (max-width: 394px) {
    .mds-alert-content[class$="-Alert"] {
      flex-direction: column;
      align-items: center;
    }
  }

`

export default GlobalStyle
